<script setup>
import {defineProps, onMounted, onUnmounted, nextTick, ref} from "vue";
import { useScreen } from 'vue-screen';
const screen = useScreen();

defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  imageAlign: {
    type: String,
    default: 'left'
  },
  logo: {
    type: String,
    default: ''
  },
  image: {
    type: String,
    default: ''
  },
  isList: {
    type: Boolean,
    default: false
  },
});

const scrolled = ref(false);
const containerRef = ref(null);

const checkScroll = () => {
  if (containerRef?.value) {
    const rect = containerRef?.value.getBoundingClientRect();
    const triggered = screen > 1023
      ? rect.top + rect.height / 2 <= window.innerHeight
      : rect.top < window.innerHeight / 2;
    if (triggered) {
      scrolled.value = true;
      window.removeEventListener('scroll', checkScroll);
    }
  }
}

onMounted(() => {
  window.addEventListener('scroll', checkScroll);
  nextTick(() => {
    checkScroll();
  })
})
onUnmounted(() => {
  window.removeEventListener('scroll', checkScroll);
});

</script>

<template>
  <div :class="['info-block', `_${imageAlign}`,{'_scrolled': scrolled, '_list': isList}]" ref="containerRef">
    <div class="info-block__inner">
      <template v-if="!isList">
        <div class="info-block__title">
          <h2 v-html="title"></h2>
          <img :src="logo" alt="" loading="lazy" />
        </div>
        <div class="info-block__columns">
          <img :src="image" alt="" loading="lazy">
          <div>
            <svg width="47" height="39" viewBox="0 0 47 39" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M33.7474 0C30.562 0 23.9508 0 21.7871 13.1195C20.4949 20.8598 17.64 26.9264 13.0723 31.6184C10.8184 33.9195 7.18223 36.7885 3.66624 37.8644L0 39H11.2391C24.6119 39 31.734 37.0276 36.6925 31.9471C43.9348 24.446 44.9265 16.377 46.1886 6.18621C46.399 4.42299 46.6394 2.57011 46.9098 0.687356L47 0.0298851H33.7474V0Z" fill="#EB2227"/>
            </svg>
            <div v-html="description"></div>
          </div>
        </div>
      </template>
      <div class="info-block__list" v-else>
          <div v-html="description"></div>
      </div>
    </div>
  </div>
</template>